import { Reducer } from 'redux';
import { UiMessage } from 'models/UiMessageModel';
import { UiMessageActions, UiMessageActionType } from 'redux/actions/UiMessageActions';

const initialState: UiMessage[] = [];

export const uiMessageReducer: Reducer<UiMessage[] | null, UiMessageActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case UiMessageActionType.SHOW:
                {
                    return action.messageData;
                }
            case UiMessageActionType.CLEAR:
                {
                    return null;
                }
            default:
                return state;
        }
    };
